export const AI_SIDEPANEL_MINWIDTH_PX = 320;
export const AI_SIDEPANEL_EXPANDED_PX = AI_SIDEPANEL_MINWIDTH_PX * 2;
